import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { BrowserRouter, HashRouter } from "react-router-dom";
import App from "./App";
import "./styles.css";
import "./brand-system.css";

const usesHashRouter = import.meta.env.VITE_HASH_ROUTER === "1";
const Router = usesHashRouter ? HashRouter : BrowserRouter;
const root = document.getElementById("root");

if (root) {
  const application = (
    <React.StrictMode>
      <Router>
        <App />
      </Router>
    </React.StrictMode>
  );

  if (!usesHashRouter && root.hasChildNodes()) {
    hydrateRoot(root, application);
  } else {
    createRoot(root).render(application);
  }
}
